import ReactDOM from 'react-dom'
import App from '@react/poi'
import { AppProvider } from '@react/poi/Context'
import modal from '@scripts/components/modal'

const el = document.getElementById('app')
const data = JSON.parse(el.dataset.json)

modal.init()

ReactDOM.render(
  <AppProvider>
    <App data={data} />
  </AppProvider>,
  el
)
